module.exports = __webpack_public_path__ + "static/img/2-34-错发换货选择订单商品.4215bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-34-错发换货选择订单商品.png
// module id = 1360
// module chunks = 0